/* ICON THEORY™ — global theme JS (vanilla, Dawn-compatible) */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = window.themeStrings && window.themeStrings.moneyFormat;
    const amount = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{amount}}') !== -1) {
      return fmt.replace('{{amount}}', amount);
    }
    return '$' + amount;
  };

  /* ---- Cart count badge ---- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => setCartCount(cart.item_count))
      .catch(() => {});
  }

  /* ---- Add to cart (quick add buttons + product form) ---- */
  function addToCart(id, quantity, btn) {
    if (btn) { btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    })
      .then((r) => r.json())
      .then(() => refreshCartCount())
      .catch(() => {})
      .finally(() => { if (btn) { btn.disabled = false; } });
  }

  document.addEventListener('click', function (e) {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      const id = quick.getAttribute('data-quick-add');
      if (id) {
        const original = quick.textContent;
        quick.textContent = '✓';
        addToCart(id, 1, quick).then(() => {
          setTimeout(() => { quick.textContent = original; }, 1100);
        });
      }
    }
  });

  /* ---- Product form (variant selection + add) ---- */
  function initProductForm(form) {
    const data = window.__productData;
    if (!data) return;
    const idInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-current-price]');
    const addBtn = form.querySelector('[data-add-btn]');

    function getSelectedOptions() {
      return Array.from(form.querySelectorAll('.variant-pills input:checked')).map((i) => i.value);
    }
    function matchVariant() {
      const opts = getSelectedOptions();
      return data.variants.find((v) =>
        v.options.every((o, idx) => o === opts[idx])
      );
    }
    function update() {
      const v = matchVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.dataset.addLabel || 'Add to cart') : 'Sold out';
      }
    }
    form.querySelectorAll('.variant-pills input').forEach((i) =>
      i.addEventListener('change', update)
    );
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);
      const btn = addBtn;
      const original = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Adding…';
      addToCart(idInput.value, qty, btn).then(() => {
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = original; }, 1200); }
      });
    });
  }

  /* ---- Qty steppers ---- */
  document.addEventListener('click', function (e) {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (dec || inc) {
      const box = (dec || inc).closest('.qty-box');
      const input = box.querySelector('input');
      let v = parseInt(input.value || '1', 10);
      v = inc ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---- Cart line qty change ---- */
  document.addEventListener('change', function (e) {
    const line = e.target.closest('[data-cart-qty]');
    if (line) {
      const key = line.getAttribute('data-cart-qty');
      const qty = parseInt(line.value || '0', 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then(() => window.location.reload());
    }
  });

  /* ---- Product thumbnails ---- */
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = document.querySelector('[data-main-media] img');
      if (main) main.src = thumb.getAttribute('data-thumb');
    }
  });

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) {
      const links = document.querySelector('.nav-links');
      if (links) links.classList.toggle('open');
    }
  });

  /* ---- Newsletter (uses native Shopify form post; no JS needed) ---- */

  document.addEventListener('DOMContentLoaded', function () {
    refreshCartCount();
    const pf = document.querySelector('[data-product-form]');
    if (pf) initProductForm(pf);
  });
})();
